import {createFileRoute} from '@tanstack/react-router';

import {EditClientPage} from '@/modules/clients/pages/EditClientPage';

const RouteComponent = () => {
  const {clientId} = Route.useParams();
  return <EditClientPage clientId={clientId} />;
};

export const Route = createFileRoute('/_authenticated/clients/$clientId_/edit')({
  component: RouteComponent,
});
